export function roleHome(role) {
  if (role === "admin" || role === "superadmin") return "/admin";
  if (role === "staff") return "/staff";
  if (role === "coach") return "/coach";
  return "/dashboard";
}
